module.exports = __webpack_public_path__ + "static/media/d2kz.ed304498.pdf";